<template>
  <div class="wrapper">
    <!-- 标题区域 -->
    <div class="page-header">
      <div class="header-content">
        <h2 class="page-title">
          <i class="el-icon-edit-outline title-icon"></i>
          {{ $route.meta.name }}
        </h2>
      </div>
    </div>

    <!-- 表单卡片 -->
    <el-card class="form-card" shadow="never">
      <el-tabs v-model="activeName" class="form-tabs">
        <el-tab-pane name="1">
          <span slot="label">
            <i class="el-icon-document"></i>
            <span>基本信息</span>
          </span>
        </el-tab-pane>
        <el-tab-pane name="2">
          <span slot="label">
            <i class="el-icon-s-grid"></i>
            <span>规格/库存</span>
          </span>
        </el-tab-pane>
        <el-tab-pane name="3">
          <span slot="label">
            <i class="el-icon-picture"></i>
            <span>商品详情</span>
          </span>
        </el-tab-pane>
      </el-tabs>
      
      <div class="form-content">
        <el-form ref="form" :model="formData" :disabled="formData.status == 1" label-width="120px" class="wrapper-form">
          <!-- 基本信息 -->
          <div v-show="activeName == 1" class="baseInfo-1">
            <el-form-item label="商品标题" prop="goodsTitle" :rules="rules">
              <el-input
                v-model="formData.goodsTitle"
                placeholder="请输入商品标题"
                class="form-input"
              ></el-input>
            </el-form-item>
            <el-form-item label="商品副标题" prop="subTitle" :rules="rules">
              <el-input
                v-model="formData.subTitle"
                placeholder="请输入商品副标题"
                class="form-input"
              ></el-input>
            </el-form-item>
            <el-form-item label="商品标签" prop="goodsTagList" :rules="rules">
              <div class="goods-tags">
                <el-tag
                  :key="tag"
                  v-for="tag in formData.goodsTagList"
                  :closable="formData.status != 1"
                  :disable-transitions="false"
                  @close="handleClose(tag)"
                  class="goods-tag"
                >
                  {{ tag }}
                </el-tag>
                <el-input
                  class="input-new-tag"
                  v-if="inputVisible"
                  v-model="inputValue"
                  ref="saveTagInput"
                  @keyup.enter.native="handleInputConfirm"
                  @blur="handleInputConfirm"
                  placeholder="输入标签"
                >
                </el-input>
                <el-button
                  v-else
                  class="button-new-tag"
                  size="small"
                  @click="showInput"
                  icon="el-icon-plus"
                >
                  新增标签
                </el-button>
              </div>
            </el-form-item>
            <el-form-item label="详情标题" prop="detailTitle" :rules="rules">
              <el-input
                type="textarea"
                v-model="formData.detailTitle"
                placeholder="请输入详情标题"
                :rows="3"
                class="form-textarea"
              ></el-input>
            </el-form-item>
            <el-form-item label="商品分类" class="goods-category" prop="categoryId" :rules="rules">
              <SelectGoodsCategory v-model="formData.categoryId" ref="goodsCategory" class="form-select"></SelectGoodsCategory>
            </el-form-item>
            <el-form-item label="成色" prop="goodsPurity" :rules="rules">
              <SelectDict v-model="formData.goodsPurity" dictCode="goods:purity" class="form-select"></SelectDict>
            </el-form-item>
            <el-form-item label="品牌" prop="brand" :rules="rules">
              <el-select
                v-model="formData.brand"
                placeholder="请选择品牌"
                clearable
                class="form-select"
              >
                <el-option v-for="item in brandList" :key="item.enumCode" :label="item.enumText" :value="item.enumCode" />
              </el-select>
            </el-form-item>

            <el-form-item :rules="rules" label="账单期数" prop="billPeriodNum">
              <el-input
                v-model.number="formData.billPeriodNum"
                clearable
                placeholder="请输入账单期数"
                class="form-input"
              />
            </el-form-item>
          </div>
          <!-- 规格/库存 -->
          <div v-show="activeName == 2" class="baseInfo-2">
            <Sku
              ref="sku"
              :status="formData.status"
              :priceRate="formData.priceRate"
              :skuAttrGroupList="formData.skuAttrGroupList"
              :skuFormList="formData.skuList"
              @addStock="addStock"
            />
          </div>
          <!-- 商品详情 -->
          <div v-show="activeName == 3" class="baseInfo-3">
            <el-form-item label="封面图" prop="coverImage" :rules="rules">
              <FileUpload :name.sync="formData.coverImage" :url="formData.coverImageUrl"></FileUpload>
            </el-form-item>
            <el-form-item label="主图" prop="masterImageList" :rules="rules">
              <FileUpload :isMulti="true" :name.sync="formData.masterImageList" :url="formData.masterImageUrlList"></FileUpload>
            </el-form-item>
            <el-form-item label="详情图" prop="detailImageList" :rules="rules">
              <FileUpload :isMulti="true" :name.sync="formData.detailImageList" :url="formData.detailImageUrlList"></FileUpload>
            </el-form-item>
          </div>
          <el-form-item label="" label-width="0" class="form-actions">
            <el-button 
              v-show="activeName > 1" 
              type="primary" 
              size="small" 
              @click="prev"
              icon="el-icon-arrow-left"
              class="action-btn prev-btn"
            >
              上一步
            </el-button>
            <el-button 
              v-show="activeName == 3" 
              type="primary" 
              size="small" 
              @click="save"
              icon="el-icon-check"
              class="action-btn submit-btn"
            >
              提交
            </el-button>
            <el-button 
              v-show="activeName < 3" 
              type="primary" 
              size="small" 
              @click="next"
              icon="el-icon-arrow-right"
              class="action-btn next-btn"
            >
              下一步
            </el-button>
            <el-button 
              type="info" 
              size="small" 
              @click="$router.back()"
              icon="el-icon-close"
              class="action-btn cancel-btn"
            >
              取消
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    
    <!-- 更新库存弹窗 -->
    <el-dialog 
      title="更新库存" 
      :visible.sync="dialogVisible" 
      width="600px"
      class="stock-dialog"
    >
      <div class="dialog-content">
        <el-form ref="stockForm" :model="stockFormData" :rules="stockFormRules" label-width="100px">
          <el-form-item label="库存" prop="stockNum">
            <el-input 
              v-model.number="stockFormData.stockNum" 
              placeholder="请输入库存数量"
              class="stock-input"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              type="textarea"
              v-model="stockFormData.remark"
              :rows="5"
              maxlength="200"
              show-word-limit
              placeholder="请输入备注信息"
              class="stock-textarea"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelStock" size="small" class="cancel-btn">取 消</el-button>
        <el-button type="primary" @click="saveStock" size="small" class="submit-btn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { editGoodsAPI, addGoodsAPI, getGoodsDetailAPI, addGoodsStockAPI, getBrandListAPI } from './api';
import { EnumGoodsType } from "@/enum/dict/index.js";
import SelectGoodsCategory from '@/views/components/select-goods-category.vue';
import SelectDict from '@/views/components/select-dict.vue';
import FileUpload from '@/components/file-upload/index.vue';
import Sku from './sku-form.vue';

export default {
  name: 'GoodsAddOrEdit',
  components: { FileUpload, SelectGoodsCategory, SelectDict, Sku },
  data() {
    return {
      activeName: '1',
      formData: {
        categoryId: null,
        goodsTitle: '',
        subTitle: '',
        detailTitle: '',
        goodsTagList: [],
        brand: '',
        insurancePrice: null,
        periodInterval: 1,
        periodUnit: 'month',
        billPeriodNum: null,
        coverImage: '',
        coverImageUrl: '',
        masterImageList: [],
        masterImageUrlList: [],
        detailImageList: [],
        detailImageUrlList: [],
        isRecommend: 1,
        skuList: [],
        goodsPurity: '',
      },
      inputVisible: false,
      inputValue: '',
      rules: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
      stockFormData: {
        id: '',
        stockNum: 0,
        remark: ''
      },
      stockFormRules: {
        stockNum: [{ required: true, message: '请输入库存', trigger: 'blur' }]
      },
      dialogVisible: false,
      brandList: [],
    }
  },

  mounted() {
    this.getBrandList();
    if (this.$route.params.id) {
      this.getGoodsDetail()
    }
  },
  computed: {
    validateTab() {
      let active = ''
      const {
        goodsTitle,
        subTitle,
        goodsTagList,
        detailTitle,
        categoryId,
        brand,
        coverImage,
        masterImageList,
        detailImageList,
        goodsPurity,
      } = this.formData
      const tab1 =
        goodsTitle &&
        subTitle &&
        goodsTagList.length &&
        detailTitle &&
        categoryId &&
        brand &&
        goodsPurity
      const tab3 = coverImage && masterImageList.length && detailImageList.length
      const tab2 = this.formData.skuList.length > 0

      if (!tab1) {
        return (active = '1')
      } else if (!tab2) {
        return (active = '2')
      } else if (!tab3) {
        return (active = '3')
      }
      return active
    }
  },

  watch: {
    'formData.billPeriodNum': {
      handler(newV, oldV) {}
    }
  },

  methods: {
    async getBrandList() {
      this.brandList = await getBrandListAPI({
        goodsType: EnumGoodsType.A,
      });
    },

    // 保存商品
    save() {
      this.$refs.form.validate(() => {
        this.formData.skuList = this.$refs.sku.skuList
        this.formData.rentPrice = this.$refs.sku.rentPrice

        if (this.activeName == 3) {
          if (this.formData.id) {
            // 编辑
            editGoodsAPI(this.formData).then(() => {
              this.$message.success('编辑成功')
              this.$router.back()
            })
          } else {
            // 新增
            addGoodsAPI(this.formData).then(() => {
              this.$message.success('新增成功')
              this.$router.back()
            })
          }
        } else {
          this.activeName = this.validateTab
          if (this.validateTab == 2) this.$message.error('商品规格必填！')
        }
      })
    },

    // 商品详情
    async getGoodsDetail() {
      this.formData = await getGoodsDetailAPI(this.$route.params.id)
    },

    handleClose(tag) {
      this.formData.goodsTagList.splice(this.formData.goodsTagList.indexOf(tag), 1)
    },

    showInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        this.formData.goodsTagList.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },

    next() {
      this.activeName++
      this.activeName = this.activeName + ''
    },

    prev() {
      this.activeName = this.activeName - 1
      this.activeName = this.activeName + ''
    },

    addStock({ id, stockNum }) {
      this.dialogVisible = true
      this.stockFormData.id = id
      this.stockFormData.stockNum = stockNum
    },

    cancelStock() {
      this.dialogVisible = false
      this.stockFormData = { id: '', stockNum: 0, remark: '' }
    },

    saveStock() {
      this.$refs.stockForm.validate(valid => {
        console.log('valid', valid)
        if (valid) {
          addGoodsStockAPI(this.stockFormData).then(() => {
            this.dialogVisible = false
            this.$message.success('增加成功')
            this.getGoodsDetail()
            this.stockFormData = { id: '', stockNum: 0, remark: '' }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  padding: 20px;
  min-height: calc(100vh - 84px);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 200px;
    pointer-events: none;
    z-index: 0;
  }
}

// 页面标题区域
.page-header {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 24px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
  }
  
  .page-title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #1a1e25;
    display: flex;
    align-items: center;
    gap: 12px;
    letter-spacing: -0.5px;
    
    .title-icon {
      font-size: 24px;
      background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }
}

// 表单卡片样式
.form-card {
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #409EFF 0%, #66b1ff 50%, #85c1ff 100%);
  }

  &:hover {
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
  }

  ::v-deep .el-card__body {
    padding: 0;
  }
  
  .form-tabs {
    border-bottom: 2px solid #f0f2f5;
    padding: 0 24px;
    background: #fafbfc;
    
    ::v-deep .el-tabs__header {
      margin: 0;
      
      .el-tabs__nav-wrap {
        &::after {
          display: none;
        }
      }
      
      .el-tabs__item {
        font-size: 15px;
        font-weight: 500;
        color: #606266;
        padding: 16px 24px;
        height: auto;
        line-height: 1.5;
        transition: all 0.3s ease;
        border-bottom: 2px solid transparent;
        margin-right: 8px;
        
        span {
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }
        
        i {
          font-size: 16px;
          transition: all 0.3s ease;
        }
        
        &:hover {
          color: #409EFF;
          
          i {
            color: #409EFF;
          }
        }
        
        &.is-active {
          color: #409EFF;
          font-weight: 600;
          border-bottom-color: #409EFF;
          
          i {
            color: #409EFF;
          }
        }
      }
      
      .el-tabs__active-bar {
        display: none;
      }
    }
  }
  
  .form-content {
    padding: 24px 28px;
    max-height: calc(100vh - 300px);
    overflow-y: auto;
    
    // 自定义滚动条
    &::-webkit-scrollbar {
      width: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f5f7fa;
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #c0c4cc;
      border-radius: 3px;
      
      &:hover {
        background: #909399;
      }
    }
  }
}

// 表单样式
.wrapper-form {
  .el-form-item {
    margin-bottom: 24px;
    
    .el-form-item__label {
      color: #303133;
      font-weight: 600;
      letter-spacing: 0.3px;
      font-size: 14px;
      position: relative;
      
      &::after {
        content: ':';
        margin-left: 2px;
        color: #909399;
      }
    }
    
    .el-form-item__content {
      .form-input,
      .form-select,
      .form-textarea {
        width: 500px;
        
        ::v-deep .el-input__inner {
          border-radius: 10px;
          height: 42px;
          line-height: 42px;
          border: 1.5px solid #E4E7ED;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          background: #fafbfc;
          font-size: 14px;
          padding-left: 15px;

          &:hover {
            border-color: #C0C4CC;
            background: #ffffff;
          }
        }
        
        ::v-deep .el-input__inner:focus {
          border-color: #409EFF;
          box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
          background: #ffffff;
        }
      }
      
      .form-textarea {
        ::v-deep .el-textarea__inner {
          border-radius: 10px;
          border: 1.5px solid #E4E7ED;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          background: #fafbfc;
          font-size: 14px;
          padding: 12px 15px;

          &:hover {
            border-color: #C0C4CC;
            background: #ffffff;
          }
          
          &:focus {
            border-color: #409EFF;
            box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
            background: #ffffff;
          }
        }
      }
      
      .goods-tags {
        width: 500px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 10px;
        
        .goods-tag {
          border-radius: 6px;
          font-size: 13px;
          transition: all 0.3s ease;
          
          &:hover {
            transform: translateY(-1px);
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
          }
        }
        
        .button-new-tag {
          border-radius: 6px;
          padding: 6px 16px;
          font-size: 13px;
          border: 1.5px dashed #409EFF;
          color: #409EFF;
          background: #f0f7ff;
          transition: all 0.3s ease;
          
          &:hover {
            background: #e6f2ff;
            border-color: #66b1ff;
            transform: translateY(-1px);
          }
        }
        
        .input-new-tag {
          width: 120px;
          
          ::v-deep .el-input__inner {
            border-radius: 6px;
            height: 32px;
            line-height: 32px;
            border: 1.5px solid #409EFF;
            padding: 0 10px;
          }
        }
      }
      
      .prepay-checkbox-group {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        padding: 16px;
        background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%);
        border-radius: 10px;
        border: 1px solid #e4e7ed;
        
        .prepay-checkbox {
          margin: 0;
          
          ::v-deep .el-checkbox__label {
            font-size: 14px;
            color: #606266;
            padding-left: 8px;
          }
          
          ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
            background-color: #409EFF;
            border-color: #409EFF;
          }
        }
      }
    }
    
    &.form-actions {
      margin-top: 32px;
      padding-top: 24px;
      border-top: 2px solid #f0f2f5;
      display: flex;
      justify-content: center;
      gap: 12px;
      
      .action-btn {
        border-radius: 10px;
        padding: 10px 24px;
        font-weight: 600;
        font-size: 13px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        letter-spacing: 0.3px;
        
        &.prev-btn,
        &.next-btn,
        &.submit-btn {
          background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
          border: none;
          box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
          
          &:hover {
            background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
            box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
            transform: translateY(-2px);
          }
          
          &:active {
            transform: translateY(0);
            box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
          }
        }
        
        &.cancel-btn {
          background: linear-gradient(135deg, #a4a9b0 0%, #909399 100%);
          border: none;
          box-shadow: 0 2px 8px rgba(144, 147, 153, 0.25);
          
          &:hover {
            background: linear-gradient(135deg, #909399 0%, #82848a 100%);
            box-shadow: 0 4px 12px rgba(144, 147, 153, 0.35);
            transform: translateY(-2px);
          }
          
          &:active {
            transform: translateY(0);
            box-shadow: 0 2px 8px rgba(144, 147, 153, 0.25);
          }
        }
      }
    }
  }
}

// 文件上传组件样式优化
::v-deep .avatar-uploader {
  .el-upload {
    border: 2px dashed #d9d9d9;
    border-radius: 12px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;
    background: #fafbfc;
    
    &:hover {
      border-color: #409EFF;
      background: #f0f7ff;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
    }
  }
  
  .avatar-uploader-icon {
    font-size: 32px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
    transition: all 0.3s ease;
    
    &:hover {
      color: #409EFF;
    }
  }
  
  .avatar {
    width: 148px;
    height: 148px;
    display: block;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    
    &:hover {
      transform: scale(1.02);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }
}

.goods-sku,
.baseInfo-2 {
  ::v-deep .avatar-uploader {
    .avatar-uploader-icon {
      font-size: 24px;
      width: 60px;
      height: 60px;
      line-height: 60px;
    }
    
    .avatar {
      width: 60px;
      height: 60px;
    }
  }
}

// 库存对话框样式
::v-deep .stock-dialog {
  .el-dialog {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15), 0 4px 16px rgba(0, 0, 0, 0.1);
    
    .el-dialog__header {
      padding: 24px 28px;
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
      border-bottom: 2px solid #f0f2f5;
      
      .el-dialog__title {
        font-size: 18px;
        font-weight: 700;
        color: #1a1e25;
      }
    }
    
    .el-dialog__body {
      padding: 0;
    }
    
    .el-dialog__footer {
      padding: 20px 28px;
      background: linear-gradient(135deg, #fafbfc 0%, #f5f7fa 100%);
      border-top: 2px solid #f0f2f5;
    }
  }
}

.dialog-content {
  padding: 24px 28px;
  
  .el-form-item {
    margin-bottom: 24px;
    
    .el-form-item__label {
      color: #303133;
      font-weight: 600;
      font-size: 14px;
    }
    
    .stock-input {
      width: 300px;
      
      ::v-deep .el-input__inner {
        border-radius: 10px;
        height: 42px;
        line-height: 42px;
        border: 1.5px solid #E4E7ED;
        padding: 0 15px;
        box-sizing: border-box;
        
        &:hover {
          border-color: #C0C4CC;
        }
        
        &:focus {
          border-color: #409EFF;
          box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
        }
      }
    }
    
    .stock-textarea {
      width: 300px;
      
      ::v-deep .el-textarea__inner {
        border-radius: 10px;
        border: 1.5px solid #E4E7ED;
        padding: 12px 15px;
        
        &:hover {
          border-color: #C0C4CC;
        }
        
        &:focus {
          border-color: #409EFF;
          box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
        }
      }
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  
  .cancel-btn {
    border-radius: 10px;
    padding: 10px 24px;
    font-weight: 600;
    font-size: 13px;
    background: linear-gradient(135deg, #a4a9b0 0%, #909399 100%);
    border: none;
    box-shadow: 0 2px 8px rgba(144, 147, 153, 0.25);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    
    &:hover {
      background: linear-gradient(135deg, #909399 0%, #82848a 100%);
      box-shadow: 0 4px 12px rgba(144, 147, 153, 0.35);
      transform: translateY(-2px);
    }
  }
  
  .submit-btn {
    border-radius: 10px;
    padding: 10px 24px;
    font-weight: 600;
    font-size: 13px;
    background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
    border: none;
    box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    
    &:hover {
      background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
      box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
      transform: translateY(-2px);
    }
  }
}

// 响应式设计
@media (max-width: 1400px) {
  .form-content {
    .wrapper-form {
      .el-form-item {
        .el-form-item__content {
          .form-input,
          .form-select,
          .form-textarea {
            width: 100% !important;
          }
          
          .goods-tags {
            width: 100%;
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .wrapper {
    padding: 12px;
  }
  
  .page-header .header-content {
    padding: 16px;
    
    .page-title {
      font-size: 20px;
    }
  }
  
  .form-card {
    border-radius: 12px;
    
    .form-content {
      padding: 16px;
    }
    
    .form-tabs {
      padding: 0 16px;
      
      ::v-deep .el-tabs__header {
        .el-tabs__item {
          padding: 12px 16px;
          font-size: 14px;
          
          i {
            display: none;
          }
        }
      }
    }
  }
}
</style>
